import Payroll from './Payroll';

export default Payroll;